/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { filterFields, getTextColorBasedOnBg } from "../../Utils/Utils";
import { AlertModel, AlertPerEntitiesModel } from "../../Utils/Models";
import AddNewAlert from "./AddNewAlert";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Add, Delete } from "@mui/icons-material";
import { RuleOptions } from "../../Utils/Constants";
import { postData } from "../../Services/postData";
import { deleteData } from "../../Services/deleteData";
import { Autocomplete, IconButton, Paper, TextField } from "@mui/material";
import { AlertsProps } from "../../Utils/Types";
import styles from "../../Styles/alerts.module.css";

export default function Alerts(props: AlertsProps) {
  const { model, excludedFields, id, modelType } = props;
  const [alerts, setAlerts] = useState<AlertModel[]>([]);
  const [workaround, setWorkaround] = useState(null);
  const [alertsForProduct, setAlertsForProduct] = useState<
    AlertPerEntitiesModel[]
  >([]);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const propertyOptions = filterFields(model, excludedFields);

  /**
   *
   */
  useEffect(() => {
    getAlerts();
    getAlertsForProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   *
   */
  const getAlerts = () => {
    getData(endpoints.alert.main).then((response) => {
      if (response && response.data && response.data) setAlerts(response.data);
    });
  };

  /**
   *
   */
  const getAlertsForProduct = () => {
    getData(`${endpoints.alertPerEntity.main}/${id}`).then((response) => {
      if (response && response.data) {
        setAlertsForProduct(response.data);
      }
    });
  };

  /**
   *
   * @param alert
   */
  const addNewAlert = async (alert: AlertModel) => {
    const response = await postData(endpoints.alert.main, alert);
    if (response && response.data && response.data) {
      getAlerts();
    }
    setOpenAlertModal(false);
  };

  /**
   *
   * @param alertForProduct
   */
  const deleteAlertForProduct = async (
    alertForProduct: AlertPerEntitiesModel
  ) => {
    const response = await deleteData(
      `${endpoints.alertPerEntity.main}/${alertForProduct._id}`
    );
    if (response && response.data && response.data) {
      getAlertsForProduct();
    }
  };

  /**
   *
   * @param param0
   * @returns
   */
  const AddButtonForAutocomplete = ({ children, ...other }: any) => {
    return (
      <Paper {...other}>
        <div className={styles.addButtonForAutocomplete}>
          <IconButton
            onMouseDown={(e) => {
              e.preventDefault();
              setOpenAlertModal(true);
            }}
            className={styles.addButtonForAutocompleteIconButton}
          >
            <Add className={styles.addIcon} />
          </IconButton>
        </div>
        {children}
      </Paper>
    );
  };

  /**
   *
   * @param e
   * @param newValue
   * @returns
   */
  const saveAlertForProduct = async (e: any, newValue: any) => {
    setWorkaround(newValue);
    if (!newValue) return;
    const alertPerItems = new AlertPerEntitiesModel();
    alertPerItems.alert = newValue._id;
    alertPerItems.model = id;
    alertPerItems.modelType = modelType;
    const response = await postData(
      endpoints.alertPerEntity.main,
      alertPerItems
    );
    if (response && response.data && response.data) {
      getAlertsForProduct();
    }
  };

  /**
   *
   */
  const handleCloseAlertModal = () => {
    setOpenAlertModal(false);
    getAlerts();
  };

  return (
    <div className={styles.entityAlertContainer}>
      <Autocomplete
        options={alerts}
        getOptionLabel={(option: any) => option.name}
        value={workaround}
        onChange={(event, newValue) => {
          saveAlertForProduct(event, newValue);
        }}
        PaperComponent={({ children, ...other }) =>
          AddButtonForAutocomplete({
            children,
            fieldName: "type",
            ...other,
          })
        }
        getOptionDisabled={(option) =>
          alertsForProduct &&
          !!alertsForProduct.find(
            (element: any) => element.alert._id === option._id
          )
        }
        renderInput={(params) => (
          <TextField {...params} label={Vocabulary.alert} size="small" />
        )}
      />
      <div>
        {alertsForProduct?.map(
          (alertForProduct: AlertPerEntitiesModel, index: number) => (
            <div
              key={alertForProduct._id}
              className={styles.alertItemContainer}
            >
              <div
                style={{
                  flex: 1,
                  marginTop: 20,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: alertForProduct.alert.color,
                  padding: "0px 10px",
                  borderRadius: 5,
                  color: getTextColorBasedOnBg(alertForProduct.alert.color),
                }}
              >
                <p style={{ flex: 1 }}> {alertForProduct.alert.name}</p>
                <p>
                  {alertForProduct.alert.property
                    ? Vocabulary[alertForProduct.alert.property]
                    : alertForProduct.alert.property}
                </p>
                &nbsp;&nbsp;
                <p> {alertForProduct.alert.rule}</p>
                &nbsp;&nbsp;
                <p> {alertForProduct.alert.threshold}</p>
              </div>
              <Delete
                className={styles.deleteIcon}
                onClick={() => deleteAlertForProduct(alertForProduct)}
              />
            </div>
          )
        )}
      </div>
      {openAlertModal ? (
        <AddNewAlert
          editAlert={null}
          open={openAlertModal}
          propertyOptions={propertyOptions}
          ruleOptions={RuleOptions}
          onClose={handleCloseAlertModal}
          addOrUpdateAlert={(alert: AlertModel) => addNewAlert(alert)}
        />
      ) : null}
    </div>
  );
}
